import { render } from "./role_setting.vue?vue&type=template&id=87b7839e&scoped=true"
import script from "./role_setting.vue?vue&type=script&lang=js"
export * from "./role_setting.vue?vue&type=script&lang=js"

import "./role_setting.vue?vue&type=style&index=0&id=87b7839e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b7839e"]])

export default __exports__